import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  files: [],
  loading: false,
  error: null,
  uploadLoading: false,
  deleteLoading: false,
};

const filesSlice = createSlice({
  name: "files",
  initialState,
  reducers: {
    setFilesLoading: (state, action) => {
      state.loading = action.payload;
    },
    setFilesError: (state, action) => {
      state.error = action.payload;
    },
    setFiles: (state, action) => {
      state.files = action.payload;
    },
    setUploadLoading: (state, action) => {
      state.uploadLoading = action.payload;
    },
    setDeleteLoading: (state, action) => {
      state.deleteLoading = action.payload;
    },
    addFile: (state, action) => {
      state.files.push(action.payload);
    },
    removeFileFromState: (state, action) => {
      state.files = state.files.filter((file) => file.id !== action.payload);
    },
    removeFilesByIds: (state, action) => {
      state.files = state.files.filter(
        (file) => !action.payload.includes(file.id)
      );
    },
    clearFilesError: (state) => {
      state.error = null;
    },
  },
});

export const {
  setFilesLoading,
  setFilesError,
  setFiles,
  setUploadLoading,
  setDeleteLoading,
  addFile,
  removeFileFromState,
  removeFilesByIds,
  clearFilesError,
} = filesSlice.actions;

export default filesSlice.reducer;
